import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Range, getTrackBackground } from 'react-range'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'

import popupInfoBG from '../../images/popup_info_bg.svg'
import popupInfoMobileBG from '../../images/popup_info_mobile_bg.svg'
import pocketMoneyDetermineBG from '../../images/parent/chapter/pocket_money_determine_bg.svg'

const PocketMoneyDetermineWrapper = styled.div`
  position: relative;
  padding-top: 20px;
  padding-bottom: 50px;
  @media (max-width: 575px) {
    padding-bottom: 20px;
  }
  &:after {
    position: absolute;
    top: 0;
    left: 70%;
    right: 0;
    bottom: 0;
    display: block;
    @media (min-width: 1200px) {
      content: '';
    }
  }
`

const PocketMoneyDetermineContainer = styled(Container)`
  position: relative;
  z-index: 5;
`

const PocketMoneyDetermineTitleWrapper = styled(Col)`
  @media (min-width: 576px) and (max-width: 1199px) {
    /* text-align: center; */
  }
`

export const PocketMoneyDetermineTitle = styled.h2`
  display: inline-block;
  font-family: ${(props) => props.theme.fontBNPPSansCondensed};
  font-size: 44px;
  font-weight: 700;
  text-align: left;
  text-transform: uppercase;
  line-height: 1.1;
  margin-bottom: 60px;
  @media (min-width: 1200px) and (max-width: 1399px) {
    margin-bottom: 50px;
  }
  @media (max-width: 767px) {
    font-size: 34px;
  }
  & > span {
    position: relative;
    display: block;
    text-transform: lowercase;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 70%;
      bottom: -33px;
      display: block;
      height: 3px;
      background-color: #91bd24;
    }
    span {
      color: ${(props) => props.theme.colorGreenLight};
    }
  }
`

const PocketMoneyDetermineDescRowWrapper = styled(Row)`
  position: relative;
  padding-bottom: 60px;
  &:before {
    content: '';
    position: absolute;
    top: 20%;
    left: -12%;
    right: -12%;
    bottom: 10%;
    background-image: url(${pocketMoneyDetermineBG});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 15px;
    @media (min-width: 992px) and (max-width: 1199px) {
      top: 10%;
    }
    @media (min-width: 768px) and (max-width: 991px) {
      top: 10%;
    }
    @media (max-width: 767px) {
      top: 12%;
      bottom: -5%;
    }
    @media (max-width: 575px) {
      top: 10%;
    }
  }
  &:after {
    content: '';
    position: absolute;
    left: 15px;
    right: 15px;
    bottom: 0;
    display: block;
    height: 1px;
    background-color: ${(props) => props.theme.colorGrayMiddle};
    @media (max-width: 767px) {
      content: none;
    }
  }
`

const PocketMoneyDetermineImageGirlWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 286px;
  height: 303px;
  transform: translateX(-50%);
  @media (min-width: 768px) and (max-width: 1199px) {
    left: 20%;
  }
  @media (max-width: 767px) {
    display: none;
  }
`

const PocketMoneyDetermineDescWrapper = styled(Col)`
  font-size: 18px;
  font-weight: 300;
  padding-top: 30px;
  @media (max-width: 1399px) {
    font-size: 16px;
  }
  @media (min-width: 992px) {
    padding-right: 12%;
  }
  p {
    margin-bottom: 30px;
    &:first-of-type {
      margin-bottom: 80px;
      @media (max-width: 575px) {
        margin-bottom: 50px;
      }
    }
  }
  strong,
  b {
    font-weight: 700;
  }
`

const PocketMoneyDetermineRecomendationWrapper = styled(Col)`
  @media (min-width: 992px) and (max-width: 1199px) {
    margin-left: 35%;
  }
  @media (min-width: 768px) and (max-width: 991px) {
    flex: 0 0 70%;
    max-width: 70%;
    margin-left: 25%;
  }
`

const PocketMoneyDetermineDescInnerWrapper = styled.div`
  text-align: center;
  padding-top: 10px;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

const PocketMoneyDetermineDescTitle = styled.p`
  color: ${(props) => props.theme.colorGreenLight};
  font-size: 42px;
  font-weight: 700;
  line-height: 1.3;
  @media (max-width: 767px) {
    font-size: 30px;
  }
  span {
    display: block;
    font-size: 20px;
    font-weight: 700;
    @media (max-width: 767px) {
      font-size: 22px;
      font-weight: 700;
    }
  }
`

const PocketMoneyDetermineAmount = styled.div`
  display: inline-block;
  background-color: ${(props) => props.theme.colorWhite};
  font-size: 48px;
  font-weight: 400;
  text-align: center;
  line-height: 1.2;
  padding: 4px;
  margin-bottom: 80px;
  border-radius: 6px;
  @media (max-width: 767px) {
    display: block;
    width: 220px;
    font-size: 40px;
    padding: 6px;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
  }
  span {
    display: block;
    background-color: ${(props) => props.theme.colorGreenLight};
    color: ${(props) => props.theme.colorWhite};
    font-size: 14px;
    padding-top: 3px;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 3px;
    border-radius: 6px;
    @media (max-width: 767px) {
      font-size: 12px;
    }
  }
  strong {
    font-weight: 700;
  }
`

const PocketMoneyDetermineTrackOuterWrapper = styled.div`
  display: inline-block;
  @media (max-width: 767px) {
    display: block;
    order: 2;
    margin-left: auto;
    margin-right: auto;
  }
  @media (min-width: 576px) {
    width: 80%;
  }
  @media (max-width: 767px) {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
`

const PocketMoneyDetermineTrackWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 36px;
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    display: block;
    height: 3px;
    background-color: ${(props) => props.theme.colorGreenBright};
    transform: translateY(-50%);
  }
`

const PocketMoneyDetermineTrackInnerWrapper = styled.div`
  align-self: center;
  width: 100%;
  height: 6px;
  border-radius: 4px;
  z-index: 30;
`

const PocketMoneyDetermineThumbWrapper = styled.div`
  display: flex;
  height: 80px;
  width: 80px;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colorWhite};
  color: ${(props) => props.theme.colorGreenLight};
  font-size: 38px;
  font-weight: 700;
  border: 2px solid ${(props) => props.theme.colorGreenLight};
  border-radius: 50%;
  z-index: 30;
  @media (max-width: 767px) {
    height: 60px;
    width: 60px;
    font-size: 28px;
  }
  &:before {
    content: '${(props) => (props.value === 3 ? 'Lata' : 'Lat')}';
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    right: 0;
    display: block;
    color: ${(props) => props.theme.colorGreenLight};
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    @media (max-width: 767px) {
      font-size: 18px;
      font-weight: 700;
    }
  }
  & > div {
    margin-top: 3px;
  }
`

const PocketMoneyDeterminePopupWrapper = styled.div`
  display: inline-block;
  width: 320px;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: contain;
  font-size: 14px;
  font-weight: 300;
  text-align: left;
  padding-top: 50px;
  padding-left: 100px;
  padding-right: 20px;
  padding-bottom: 50px;
  margin-top: 50px;
  @media (min-width: 768px) {
    background-image: url(${popupInfoBG});
  }
  @media (max-width: 767px) {
    display: block;
    width: 230px;
    order: 1;
    background-image: url(${popupInfoMobileBG});
    background-position: bottom left;
    font-size: 10px;
    padding-top: 50px;
    padding-left: 80px;
    padding-right: 20px;
    padding-bottom: 45px;
    margin-top: 0;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;
  }
`

const PocketMoneyDetermine = (props) => {
  const data = useStaticQuery(graphql`
    query {
      girlImage: file(relativePath: { eq: "parent/chapter/girl.png" }) {
        childImageSharp {
          fluid(maxWidth: 430) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  const [values, setValues] = useState([9])

  const STEP = 1
  const MIN = 3
  const MAX = 18

  const amounts = {
    3: 20,
    4: 20,
    5: 20,
    6: 50,
    7: 50,
    8: 50,
    9: 50,
    10: 50,
    11: 80,
    12: 80,
    13: 80,
    14: 100,
    15: 100,
    16: 100,
    17: 100,
    18: 100,
  }

  return (
    <PocketMoneyDetermineWrapper id="pocket2022">
      <PocketMoneyDetermineContainer>
        <Row>
          <PocketMoneyDetermineTitleWrapper xs={12}>
            <PocketMoneyDetermineTitle color="#91BD24">
              Jak ustalić{' '}
              <span>
                <span>wysokość</span> kieszonkowego?
              </span>
            </PocketMoneyDetermineTitle>
          </PocketMoneyDetermineTitleWrapper>
        </Row>
        <PocketMoneyDetermineDescRowWrapper>
          <PocketMoneyDetermineImageGirlWrapper>
            <Img
              fluid={data.girlImage.childImageSharp.fluid}
              alt="Czy dawanie kieszonkowego się opłaca?"
            />
          </PocketMoneyDetermineImageGirlWrapper>
          <PocketMoneyDetermineDescWrapper xs={12} xl={6}>
            <p>
              <strong>
                Dajesz swojemu dziecku kieszonkowe, ale zastanawiasz się, czy
                {'\u00A0'}wybrana kwota jest właściwa? Chcesz, by{'\u00A0'}była
                ona dopasowana do{'\u00A0'}domowego budżetu, ale zależy Ci
                {'\u00A0'}też, by{'\u00A0'}Twoje dziecko nie odstawało od
                {'\u00A0'}rówieśników i{'\u00A0'}mogło czuć się bezpiecznie?
              </strong>
            </p>
            <p>
              Sprawdziliśmy, jaką przeciętną kwotę kieszonkowego w{'\u00A0'}
              Polsce przyznają dzieciom rodzice.
              <br />
              Zobaczcie, czego się dowiedzieliśmy w ramach badania
              przeprowadzonego przez Bank BNP Paribas*.
            </p>
            <p>
              Pomóż dziecku rozwijać w{'\u00A0'}praktyce umiejętność
              gospodarowania własnym budżetem.
            </p>
          </PocketMoneyDetermineDescWrapper>
          <PocketMoneyDetermineRecomendationWrapper xs={12} md={6}>
            <PocketMoneyDetermineDescInnerWrapper>
              <PocketMoneyDetermineDescTitle>
                Najczęstsza kwota <span>kieszonkowego*</span>
              </PocketMoneyDetermineDescTitle>
              <PocketMoneyDetermineAmount>
                <strong>{amounts[`${values[0]}`]}</strong> zł{' '}
                <span>wartość miesięczna</span>
              </PocketMoneyDetermineAmount>
              <PocketMoneyDetermineTrackOuterWrapper>
                <Range
                  values={values}
                  step={STEP}
                  min={MIN}
                  max={MAX}
                  onChange={(values) => setValues(values)}
                  renderTrack={({ props, children }) => (
                    <PocketMoneyDetermineTrackWrapper
                      onMouseDown={props.onMouseDown}
                      onTouchStart={props.onTouchStart}
                      style={{
                        ...props.style,
                      }}
                    >
                      <PocketMoneyDetermineTrackInnerWrapper
                        ref={props.ref}
                        style={{
                          background: getTrackBackground({
                            values: values,
                            colors: ['#019662', 'transparent'],
                            min: MIN,
                            max: MAX,
                          }),
                        }}
                      >
                        {children}
                      </PocketMoneyDetermineTrackInnerWrapper>
                    </PocketMoneyDetermineTrackWrapper>
                  )}
                  renderThumb={({ props, isDragged }) => (
                    <PocketMoneyDetermineThumbWrapper
                      {...props}
                      value={values[0]}
                      style={{
                        ...props.style,
                      }}
                    >
                      <div>{values[0]}</div>
                    </PocketMoneyDetermineThumbWrapper>
                  )}
                />
              </PocketMoneyDetermineTrackOuterWrapper>
              <PocketMoneyDeterminePopupWrapper>
                Przesuń suwak, aby{'\u00A0'}wybrać odpowiedni wiek{'\u00A0'}
                dziecka.
              </PocketMoneyDeterminePopupWrapper>
            </PocketMoneyDetermineDescInnerWrapper>
          </PocketMoneyDetermineRecomendationWrapper>
        </PocketMoneyDetermineDescRowWrapper>
      </PocketMoneyDetermineContainer>
    </PocketMoneyDetermineWrapper>
  )
}

export default PocketMoneyDetermine
